import React from "react";
import { CardDetail } from "./cardDetail";
class CardDetailParent extends React.Component {
    render() {
        return (
            <CardDetail {...this.props} />
        )
    }
}
export default CardDetailParent